import { gql } from "@apollo/client";

export const GET_CUIDADOS_PALIATIVOS_RESUMEN = gql`
query CuidadosPaliativosRIById(
    $idDatosGenerales: Int!
){
    cuidadosPaliativosRIByDatosGeneralesId(
        idDatosGenerales: $idDatosGenerales
    ){
        cuidadosPaliativosRI {
            directivasAnticipadas
            otrosEstudios
            cuidadorPrincipal
            profesionOcupacion
            pasatiempo
            religion
            medicoCabecera
            idComboRIValorECOGNavigation{
                valor
            }
            idComboRIValorTabaquismoNavigation{
                valor
            }
            antecedenteAlcoholismo
            antecedenteConsumoSustancias
            descSustancia
            tensionArterial
            temperatura
            frecRespiratoria
            frecCardiaca
            otros
            digestivo
            videodeglucion
            respiratorio
            cV
            sNC
            pielMucosasFaneras
            aduESAS
            soporteNutricional
            sondaNasogastrica
            cateter
            sondaVesical
            resultadoAduESAS            
            idComboRIValorPedEscalaDolorNavigation{
                valor
            }
            pedGMFS
            resultadoPedGMFS
            idComboRIValorPedLANSKYNavigation{
                valor
            }
            pedFPSR
            resultadoPedGustaveRoussy
            pedGustaveRoussy
            resultadoPedFLACCR
            pedFLACCR
            resultadoPedFPSR
            escalaNumericaDolor
            resultadoEscalaNumericaDolor
            viveSolo
            claudicacionFamiliar
            cuidadoresContratados
            datosSocioEcoFamiliares
            idComboRIValorPoseeInfDiagnosticaNavigation{
                valor
            }
            idComboRIValorPoseeInfPronosticoNavigation{
                valor
            }
            idComboRIValorPoseeInfEnfermedadNavigation{
                valor
            }
            idComboRIValorNombraPalabraCancerNavigation{
                valor
            }
            idComboRIValorCercoDeSilencioNavigation{
                valor
            }
            idComboRIValorTrastornoAdaptacionNavigation{
                valor
            }
            otrasIndicaciones
            problemaEspiritual
            problemaSocial
            problemaPsicologico
            problemaFisico
            otrosDatosInformacion
            cPMedicacionDosificacionRI {
                descripcion
            }
            dolor
            disnea
            nauseas
            depresion
            ansiedad
            anorexia
            bienestar
            cansancio
            insomnio
            somnolencia
            constipacion
        }
        directivasAdjunto {
            contentType
            titulo
            archivo
            extension
        }
        videodeglucionAdjunto {
            contentType
            titulo
            archivo
            extension
        }
        estudioAdjunto {
            contentType
            titulo
            archivo
            extension
        }
        resultadoAduESASResumido    
    }
}`;